// test1605
(1605 && 0);
